import React from 'react';
import styles from './SocialButtonsList.scss';
import { IconButton } from '../IconButton/IconButton';
import classNames from 'classnames';
import { MODAL } from '../../context';
import { useApp } from '../../hooks';
import { SnapchatIcon } from '../SocialIcons/SnapchatIcon';

interface InstagramShareRoundProps {
  className?: string;
  onClick?: () => void;
}

export const SnapchatShareRound: React.FunctionComponent<InstagramShareRoundProps> = ({
  className,
  onClick = () => {},
}) => {
  const { showModal } = useApp();
  const linkItemClick = () => {
    showModal({ modal: MODAL.SNAPCHAT_SHARE, overwrite: true });
    onClick();
  };

  return (
    <>
      <IconButton
        className={`${styles.roundButton} ${className}`}
        onClick={() => linkItemClick()}
      >
        <div className={classNames(styles.iconWrapper)}>
          <SnapchatIcon width="24" height="24" className={styles.icon} />
        </div>
        Snapchat
        <div className={styles.newFeatureContainer}>
          <span>NEW</span>
        </div>
      </IconButton>
    </>
  );
};
